import { TCreateMVPRequest } from "src/services/apiEndpoint.types.ts/ideaHub/createIdea.endpoint.types";
import { IdeaHubAPIService } from "src/services/ideaHub.api.service";
import { AppDispatch } from "../store";

export const createMVP = (payload: TCreateMVPRequest) => async (dispatch: AppDispatch) => {
    try {
        const { status, data } =
            await new IdeaHubAPIService().createMVP(payload);
        return { data, status: true }
    } catch (err) {
        console.log(err);
        return { status: false }
    }
};
